module.exports = __webpack_public_path__ + "img/LUB00051.67c2f899.png";